import React from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { slugify } from 'helpers/slugify';

import MenuSectionHeader from 'components/Menu/MenuSectionHeader';
import MenuSectionList from 'catering/components/Menu/MenuSectionList';
import { useGoToMenuItem } from 'catering/hooks/navigation/useGoToMenuItem';
import { useGoToOrderSettings } from 'catering/hooks/navigation';

function MenuSection({
  section,
  shouldLazyLoadMenu,
  menuLeadTime,
  fulfillmentDateTime,
  fulfillmentMethod,
  locationInventory
}) {
  const { name, items, description } = section;
  const { locationSlug } = useParams();
  const goToMenuItem = useGoToMenuItem();
  const goToOrderSettings = useGoToOrderSettings();

  const handleMenuItemClick = (menuItemSlug, minFulfillmentDateTime = null) => {
    if (minFulfillmentDateTime) {
      goToOrderSettings({
        locationSlug,
        fulfillmentMethod,
        minFulfillmentDateTime
      });
    } else {
      goToMenuItem(menuItemSlug);
    }
  };

  return (
    <Box id={slugify(name)} data-testid="menu-section">
      <MenuSectionHeader title={name} description={description} />
      <MenuSectionList
        menuLeadTime={menuLeadTime}
        menuList={items}
        isExpanded
        handleClick={handleMenuItemClick}
        shouldLazyLoadMenu={shouldLazyLoadMenu}
        fulfillmentDateTime={fulfillmentDateTime}
        locationInventory={locationInventory}
      />
    </Box>
  );
}

MenuSection.propTypes = {
  section: PropTypes.shape({
    name: PropTypes.string,
    items: PropTypes.array,
    description: PropTypes.string
  }),
  menuLeadTime: PropTypes.shape({
    lead_time_days: PropTypes.number,
    lead_time_hours: PropTypes.number
  }).isRequired,
  shouldLazyLoadMenu: PropTypes.bool,
  locationInventory: PropTypes.object,
  fulfillmentDateTime: PropTypes.instanceOf(Date).isRequired,
  fulfillmentMethod: PropTypes.string.isRequired
};

export default MenuSection;
